import Types from './Types';
/* eslint-disable camelcase */

/************************************************
Get user details
*************************************************/

const getDashboard = (durationValue) =>{
   return ({ type: Types.GET_DASHBOARD, durationValue })};

const getDashboardSuccess = (dashboard) => ({ type: Types.GET_DASHBOARD_SUCCESS, dashboard });

const getDashboardFailure = (errorMessage) => ({
    type: Types.GET_DASHBOARD_FAILURE,
    errorMessage,
});

export {
    getDashboard,
    getDashboardSuccess,
    getDashboardFailure,
};



// WEBPACK FOOTER //
// ./src/actions/DashboardActions.js